import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddToBasketFailedPopup from './AddToBasketFailedPopup';
import { deleteAddingProductToBasketFailedPopup } from '../../../../appState/ducks/general';

class AddToBasketFailedPopupWrapper extends React.PureComponent {

  render() {

    const {
      openPopup, popupHeaderLabel, popupMessage, buttonLabel, buttonUrl, closePopup
    } = this.props;

    return (
      <>
        {openPopup
          ? (
            <AddToBasketFailedPopup
              popupHeaderLabel={popupHeaderLabel}
              popupMessage={popupMessage}
              buttonLabel={buttonLabel}
              onButtonClick={() => {
                if (buttonUrl) {
                  window.location.href = buttonUrl;
                } else {
                  closePopup();
                }
              }}
              onCloseClick={() => {
                closePopup();
              }}
            />
          )
          : <span />}
      </>
    );
  }
}


AddToBasketFailedPopupWrapper.propTypes = {
  openPopup: PropTypes.bool,
  popupHeaderLabel: PropTypes.string,
  popupMessage: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonUrl: PropTypes.string,
  closePopup: PropTypes.func
};


AddToBasketFailedPopupWrapper.defaultProps = {
  openPopup: false,
  popupHeaderLabel: '',
  popupMessage: '',
  buttonLabel: '',
  buttonUrl: '',
  closePopup: () => {}
};

function mapStateToProps({ general }) {
  return {
    openPopup: !!general.addingToBasketFailedPopup,
    popupHeaderLabel:
      general.addingToBasketFailedPopup && general.addingToBasketFailedPopup.popupHeaderLabel,
    popupMessage:
      general.addingToBasketFailedPopup && general.addingToBasketFailedPopup.popupMessage,
    buttonLabel: general.addingToBasketFailedPopup && general.addingToBasketFailedPopup.buttonLabel,
    buttonUrl: general.addingToBasketFailedPopup && general.addingToBasketFailedPopup.buttonUrl
  };
}

export default
connect(
  mapStateToProps,
  { closePopup: deleteAddingProductToBasketFailedPopup }
)(AddToBasketFailedPopupWrapper);
